import React, { Component } from "react";
import Header from "../HeaderSection/Header";
import FooterSection from "../FooterSection/Footer";
import Breadcrumb from "../Blogs/Breadcrumb";

class SayOnBeatPrivacyPolicy extends Component {
  state = { initData: [] };

  render() {
    return (
      <div>
        {/*====== Scroll To Top Area Start ======*/}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {/*====== Scroll To Top Area End ======*/}

        <div className="main">
          <Header imageData={"/img/logo-colored.png"} />
          <Breadcrumb title="Privacy Policy" />
          <div className="main"></div>

          <h3 className="nav-link" style={{ marginTop: "20px" }}>
            Say on Beat Mobile Application Privacy Policy
          </h3>
          <h5 className="nav-link" style={{ marginTop: "20px" }}>
            Effective Date: December 21, 2025
          </h5>

          <p className="nav-link" style={{ margin: "20px" }}>
            At Say on Beat, your privacy is important to us. This Privacy Policy explains how we
            collect, use, disclose, and protect information when you use our mobile application and
            services (the "App"). By using the App, you agree to the practices described here. If
            you do not agree, please do not use the App.
          </p>

          <h5 className="nav-link">1. Information We Collect</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            a. Personal Information (you provide):
            <ul>
              <li>Nickname/username and (optionally) avatar or profile image.</li>
              <li>Contact information if you reach out to support (e.g., email).</li>
              <li>Purchase/subscription identifiers provided by Apple/Google (we do not store full payment card data).</li>
            </ul>
          </p>
          <p className="nav-link" style={{ margin: "20px" }}>
            b. Device &amp; Technical Information (collected automatically):
            <ul>
              <li>Device model, OS version, app version, language, time zone.</li>
              <li>Unique identifiers (e.g., IDFV/Android Instance ID) where needed for analytics, fraud prevention, or subscriptions.</li>
              <li>Crash logs and diagnostics (e.g., via Crashlytics/Sentry).</li>
            </ul>
          </p>
          <p className="nav-link" style={{ margin: "20px" }}>
            c. Usage &amp; Gameplay Information:
            <ul>
              <li>Session IDs, game scores, match outcomes, timestamps.</li>
              <li>Basic interaction events (e.g., screens viewed, buttons tapped) to improve UX.</li>
              <li>In-app settings, preferences, cosmetics.</li>
            </ul>
          </p>

          <h5 className="nav-link">2. How We Use Your Information</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We process information to:
            <ul>
              <li>Provide core gameplay (sessions, matchmaking, leaderboards).</li>
              <li>Enable subscriptions, restore purchases, and manage entitlements.</li>
              <li>Improve app performance, stability, and user experience.</li>
              <li>Prevent cheating, abuse, and fraud; ensure fair play.</li>
              <li>Communicate important updates, features, or policy changes.</li>
              <li>Comply with legal obligations and enforce our Terms.</li>
            </ul>
          </p>

          <h5 className="nav-link">3. Legal Bases (where applicable)</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            Depending on your region, we rely on one or more of the following:
            <ul>
              <li><strong>Contractual necessity</strong> (to provide the App and features you request).</li>
              <li><strong>Legitimate interests</strong> (e.g., app security, analytics, anti-fraud, customer support).</li>
              <li><strong>Consent</strong> (where required by law, e.g., certain analytics/ads).</li>
              <li><strong>Legal obligation</strong> (to comply with applicable laws).</li>
            </ul>
          </p>

          <h5 className="nav-link">4. Information Sharing</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We do not sell your personal information. We may share information:
            <ul>
              <li>With service providers that support the App (e.g., hosting, analytics, crash reporting, payments/subscriptions).</li>
              <li>With platform providers (Apple/Google) to verify and manage purchases.</li>
              <li>To comply with laws, legal process, or to protect rights, users, or security.</li>
              <li>In connection with a business transfer (e.g., merger, acquisition), subject to applicable laws.</li>
            </ul>
          </p>

          <h5 className="nav-link">5. Analytics and (Optional) Advertising</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We may use analytics tools to understand app usage (e.g., session length, feature adoption)
            and improve the experience. If we introduce advertising or marketing technologies, we will
            update this policy and, where required, request your consent and provide opt-out options in
            settings.
          </p>

          <h5 className="nav-link">6. Data Retention</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We retain information only as long as necessary to provide the App, fulfill the purposes
            described here, comply with our legal obligations, or resolve disputes. Session data (e.g.,
            game scores, match data) is generally temporary and discarded after gameplay unless a
            longer retention period is required for security, fraud prevention, or legal reasons.
          </p>

          <h5 className="nav-link">7. Security</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We implement technical and organizational measures designed to protect your information
            from unauthorized access, alteration, disclosure, or destruction. However, no method of
            transmission or storage is 100% secure.
          </p>

          <h5 className="nav-link">8. Your Rights &amp; Controls</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            Depending on your region, you may have rights to:
            <ul>
              <li>Access, correct, or delete personal information we hold about you.</li>
              <li>Object to or restrict certain processing.</li>
              <li>Withdraw consent where processing is based on consent.</li>
              <li>Portability of certain data (where applicable).</li>
            </ul>
            To exercise rights, contact us at the email below. We may need to verify your identity. Some data
            (e.g., purchase records) may be retained as required by law or for anti-fraud.
          </p>

          <h5 className="nav-link">9. Children's Privacy</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            The App is intended for users aged 17 and above. We do not knowingly collect personal
            information from children under the age required by local law. If you believe a child has
            provided us with personal information, please contact us so we can take appropriate action.
          </p>

          <h5 className="nav-link">10. International Transfers</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We may process and store information in countries other than your own. Where required, we
            implement appropriate safeguards (e.g., standard contractual clauses) to protect your
            information during cross-border transfers.
          </p>

          <h5 className="nav-link">11. Third-Party Links &amp; Services</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            The App may include links to or integrations with third-party services (e.g., social login,
            app stores). We are not responsible for the privacy practices of third parties. We encourage
            you to review their privacy policies.
          </p>

          <h5 className="nav-link">12. Changes to This Policy</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            We may update this Privacy Policy from time to time. The "Effective Date" above indicates
            when it was last revised. Your continued use of the App after changes means you accept the
            updated policy. If changes are material, we will provide additional notice where required.
          </p>

          <h5 className="nav-link">13. Contact Us</h5>
          <p className="nav-link" style={{ margin: "20px" }}>
            If you have questions or wish to exercise your privacy rights, please contact:
            <br />
            Email: <a href="mailto:moussa@furrbud.com">moussa@furrbud.com</a>
          </p>

          <FooterSection />
        </div>
      </div>
    );
  }
}

export default SayOnBeatPrivacyPolicy;
